export const getFixed = value => {
  if (isNaN(value)) {
    return 0
  }
  return Math.floor(value * 100) / 100
}
